import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NgMediaConfigService {
  public API: BehaviorSubject<string> = new BehaviorSubject('');
  constructor() {}
}
